import React, { useState, useEffect } from 'react';
import { Card, CardBody, Button, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import RecentListings from './RecentListings';
import { useSelector } from 'react-redux';

const RecentListingsTest = () => {
  // Get the current agent from Redux store (if available)
  const currentAgent = useSelector(state => state.user?.agents);
  
  // State for the agent ID input
  const [agentId, setAgentId] = useState('');
  const [limit, setLimit] = useState(5);
  const [showListings, setShowListings] = useState(false);
  
  // Set the agent ID from Redux when component mounts
  useEffect(() => {
    if (currentAgent?.id) {
      setAgentId(currentAgent.id);
    }
  }, [currentAgent]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setShowListings(true);
  };
  
  return (
    <div className="container py-5">
      <h2 className="mb-4">Recent Listings API Test</h2>
      
      <Card className="mb-4">
        <CardBody>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label for="agentId">Agent ID</Label>
                  <Input
                    type="text"
                    id="agentId"
                    value={agentId}
                    onChange={(e) => setAgentId(e.target.value)}
                    placeholder="Enter agent ID"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="limit">Limit</Label>
                  <Input
                    type="number"
                    id="limit"
                    value={limit}
                    onChange={(e) => setLimit(parseInt(e.target.value))}
                    min="1"
                    max="10"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button color="primary" type="submit">
              Load Listings
            </Button>
          </form>
        </CardBody>
      </Card>
      
      {showListings && agentId && (
        <div className="mt-4">
          <h3 className="mb-3">Recent Listings for Agent ID: {agentId}</h3>
          <RecentListings 
            agentId={agentId} 
            limit={limit} 
            viewAllLink="/property-list" 
          />
        </div>
      )}
    </div>
  );
};

export default RecentListingsTest;
